import "./LocalSeoConsultantBelfast.module.css";
import Header from "@/reusable_sections/Header";
import Services from "./sections/Services";
import CaseStudies from "./sections/CaseStudies";
import Methodology from "./sections/Methodology";
import Hero from "./sections/Hero";
import BelfastFaq from "./sections/BelfastFaq";
import ConsultationCTA from "./sections/ConsultationCTA";
import Localseoservices from "./sections/Localseoservices";
import Belfast from "./sections/Belfast";
import Consultant from "./sections/Consultant";
import Belfastmarketanalysis from "./sections/Belfastmarketanalysis";
import Footer from "@/reusable_sections/Footer";
export default function LocalSeoConsultantBelfastPage() {
  return <div>
      <Header />
      <Services />
      <CaseStudies />
      <Methodology />
      <Hero />
      <BelfastFaq />
      <ConsultationCTA />
      <Localseoservices />
      <Belfast />
      <Consultant />
      <Belfastmarketanalysis />
      <Footer />
    </div>;
}